
<div class="d-flex gx-2 mt-2">
    @if(!isAnonymous && userInfos){
        <div class="text-secondary preview-icon pe-1">
            <username-icon context="threadInput"
                            [userInfos]="userInfos"></username-icon>
        </div>
        <div class="">
            <div class="px-3">
                {{ itemTypeText | translate }} {{'timeline-item-creation-dialog.anonymity-preview.non-anonymous' | translate}}
            </div>
        </div>
    }@else{
        <div class="text-secondary preview-icon pe-1">
            <i class="fa-solid fa-mask"></i>
        </div>
        <div class="">
            <div class="px-3">
                {{ itemTypeText | translate }} {{'timeline-item-creation-dialog.anonymity-preview.anonymous' | translate}}
            </div>
        </div>
    }
</div>


